export default function ComparisonSection() {
  return (
    <section id="porownanie" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full mb-4">
            Porównanie
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Najlepsze rozwiązania USFansSpreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Porównaj USFansSpreadsheet z innymi dostępnymi rozwiązaniami na rynku
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="py-4 px-5 text-sm font-semibold text-foreground-800">Funkcja</th>
                  <th className="py-4 px-5 text-sm font-semibold text-primary-700 bg-primary-50/50">
                    <strong>USFansSpreadsheet</strong>
                  </th>
                  <th className="py-4 px-5 text-sm font-semibold text-foreground-700">Alternatywa A</th>
                  <th className="py-4 px-5 text-sm font-semibold text-foreground-700">Alternatywa B</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: "Aktualizacje", usfans: "★★★★★", altA: "★★★★", altB: "★★★" },
                  { feature: "Łatwość użycia", usfans: "★★★★★", altA: "★★★★", altB: "★★★" },
                  { feature: "Popularność", usfans: "★★★★★", altA: "★★★", altB: "★★" },
                  { feature: "Bezpieczeństwo", usfans: "★★★★★", altA: "★★★★", altB: "★★★" },
                  { feature: "Dostępność", usfans: "★★★★★", altA: "★★★", altB: "★★" },
                  { feature: "Liczba kategorii", usfans: "14", altA: "8", altB: "5" },
                  { feature: "Częstotliwość aktualizacji", usfans: "Co tydzień", altA: "Co miesiąc", altB: "Rzadko" },
                ].map((row, i) => (
                  <tr key={i} className="border-b border-background-100 last:border-b-0 hover:bg-background-50">
                    <td className="py-3.5 px-5 text-sm text-foreground-800 font-medium">{row.feature}</td>
                    <td className="py-3.5 px-5 text-sm text-primary-700 font-semibold bg-primary-50/30">{row.usfans}</td>
                    <td className="py-3.5 px-5 text-sm text-foreground-600">{row.altA}</td>
                    <td className="py-3.5 px-5 text-sm text-foreground-600">{row.altB}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}